import { Branch } from '../base/branch';
import { Node } from '../base/node';
import { Realm } from './realm';

export class Endpoint extends Node {
    static _type: string = 'Endpoint';

    data: any = {};

    constructor(source?: any) {
        super(source);

        if (source) {
            this.data = source.data;
        }
    }

    copy(source?: any) {
        super.copy(source);

        if (source) {
            this.data = source.data;
        }
    }

    get model(): any {
        const rest = super.model;
        if (rest.data?.headers) {
            rest.data.headers = rest.data.headers.filter((header: any) => header.key?.length);
        }
        return rest;
    }

    override fit(branch: Branch): boolean {
        return branch instanceof Realm;
    }
}
